module.exports = __webpack_public_path__ + "static/media/Mujer.3723ac90.png";